import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.small";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOtherProps } from '../util';

var Spinner = /*#__PURE__*/function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner(props) {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Spinner).call(this, props));
    _this.state = {
      delayed: props.delay && true
    };
    _this.timer = null;
    return _this;
  }

  _createClass(Spinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.delay) {
        this.timer = setTimeout(function () {
          _this2.setState({
            delayed: false
          });
        }, 1000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var baseClassName = 'wds-c-spinner';
      var otherProps = getOtherProps(Spinner.propTypes, this.props);
      return React.createElement("div", _extends({
        className: classNames(baseClassName, this.state.delayed && 'wds-u-hidden', this.props.paused && "".concat(baseClassName, "--paused"), this.props.small && "".concat(baseClassName, "--small"), this.props.block && "".concat(baseClassName, "--block"), this.props.type && "".concat(baseClassName, "--").concat(this.props.type), this.props.className),
        role: "status"
      }, otherProps), React.createElement("div", {
        className: "".concat(baseClassName, "__shape")
      }, React.createElement("span", {
        className: "wds-u-sr-only"
      }, this.props.ariaLabel)));
    }
  }]);

  return Spinner;
}(Component);

Spinner.propTypes = {
  /** Additional classname */
  className: PropTypes.string,

  /** Specifies the spinner as small */
  small: PropTypes.bool,

  /** Specifies the spinner as a block. When using a spinner on its own, not inline with text e.g. in a button, use `block` to isolate it from surrounding components. */
  block: PropTypes.bool,

  /** Specifies the type of the spinner */
  type: PropTypes.oneOf(['primary', 'secondary']),

  /** The spinner will be displayed only if lasts more than 1 second being rendered */
  delay: PropTypes.bool,

  /** The spinner will be paused */
  paused: PropTypes.bool,

  /** used by screen readers to describe the spinner */
  ariaLabel: PropTypes.string.isRequired
};
Spinner.defaultProps = {
  delay: true,
  paused: false,
  small: false,
  block: false,
  type: undefined,
  className: undefined
};
export default Spinner;